// Translations
import form from '../sections/form/translations/ua'

// Translation: Reset > Landing (Ukrainian)
export default Object.freeze({
	sections: { form }
})
